module.exports = function (breakpointsService) {
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            textContent: '@',
            isExpandedLargeFormat: '@'
        },
        link(scope) {

            scope.isExpandedLargeFormat = scope.isExpandedLargeFormat === 'true' ? true : false;

            //TODO: Add toggling animations
            const _breakpointsService = breakpointsService;

            scope.isSmallFormat = _breakpointsService.isInSmallFormat;

            //Collapsed on small format and expanded on large
            if (scope.isExpandedLargeFormat) {
                scope.isExpanded = scope.isSmallFormat ? false : true;
            } else {
                //Collapsed on both formats
                scope.isExpanded = false;
            }

            scope.toggleContent = function () {
                scope.isExpanded = !scope.isExpanded;
            };

        }, template: require('./expandable-content-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/expandable-content/expandable-content-directive.js
 **/